module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.visible) ? _c('span', {
    staticClass: "aeris-spinner-host"
  }, [_c('div', {
    staticClass: "aeris-spinner-container"
  }, [_c('div', {
    staticClass: "aeris__spinner",
    class: _vm.sizeClass,
    attrs: {
      "id": "aerisSpinner"
    }
  }, [_c('span')]), _vm._v(" "), _c('div', {
    staticClass: "aeris-spinner-label"
  }, [_vm._t("default")], 2)])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-662f4f8f","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/aeris-spinner/aeris-spinner.vue
// module id = 175
// module chunks = 0